import { type AxiosError } from 'axios'
import { useCallback, useState } from 'react'
import { type UnbindIdentityRequest } from '../types/apiRequest'
import { type UnbindResponse } from '../types/apiResponse'
import { wordPressHost } from '../utils/location'
import { useRequestUnbindIdentity } from './apis/wp/useRequestUnbindIdentity'
import { mutateAllUsers } from './apis/wp/useRequestUser'

interface UseUnBindIdentityProps {
  onError?: () => void
}

export function useUnBindIdentity(props?: UseUnBindIdentityProps) {
  const { trigger, isMutating } = useRequestUnbindIdentity()
  const [unbindType, setUnbindType] = useState<UnbindIdentityRequest['type']>()

  const unbind = useCallback(async (type: UnbindIdentityRequest['type']) => {
    try {
      setUnbindType(type)
      const { data } = await trigger({
        type,
        redirectUrl: `${wordPressHost}/my-account/edit-account/?unbind${type.charAt(0).toUpperCase()}${type.slice(1)}=true`,
        fallbackUrl: `${wordPressHost}/my-account/edit-account/?unbind${type.charAt(0).toUpperCase()}${type.slice(1)}=false`,
      })
      window.location.href = data.data.url
    }
    catch (e) {
      const error = e as AxiosError<UnbindResponse>
      if (error.response?.status !== 403) {
        props?.onError?.()
        console.error(e)
        mutateAllUsers()
      }
    }
  }, [props, trigger])

  const unbindEmail = useCallback(() => unbind('email'), [unbind])
  const unbindSms = useCallback(() => unbind('sms'), [unbind])
  const unbindLine = useCallback(() => unbind('line'), [unbind])
  const unbindFacebook = useCallback(() => unbind('facebook'), [unbind])
  const unbindGoogle = useCallback(() => unbind('google'), [unbind])

  return {
    unbind,
    unbindEmail,
    unbindSms,
    unbindLine,
    unbindFacebook,
    unbindGoogle,
    isMutating,
    unbindType,
  }
}
